var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "UiSkeleton bg-gray-200 rounded animate-pulse",
    style: _vm.componentstyle,
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }